























































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import User from "@/models/user";
import SubscriptionPlan from "@/models/subscriptionPlan";
import { SubscriptionInterval } from "@/models/subscriptionInterval";
import AppSettings from "@/appsettings";
import { SET_SUBSCRIPTION_PLAN_PRICING } from "@/store/mutation-types";

@Component({
  computed: {
    ...mapState("authentication", ["user"]),
    ...mapState("subscriptions", ["subscriptionPlans"]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
})
export default class SubscriptionPlans extends Vue {
  user!: User;
  hasActiveSubscription!: boolean;
  loading = false;
  subscriptionPlans!: Array<SubscriptionPlan>;
  interval: SubscriptionInterval = AppSettings.DefaultSubscriptionInterval;
  poller!: any;
  timesPolled = 0;

  get filteredSubscriptionPlans(): Array<SubscriptionPlan> {
    return this.subscriptionPlans.filter((plan) => {
      return plan.interval === this.interval;
    });
  }

  created() {
    const that = this;
    that.loading = true;
    this.subscriptionPlans.forEach((subscriptionPlan) => {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      Paddle.Product.Prices(subscriptionPlan.id, function (prices) {
        let updatedSubscription = new SubscriptionPlan(subscriptionPlan.id);
        updatedSubscription.price = prices.recurring.price.gross;
        updatedSubscription.interval = prices.recurring.subscription.type;
        updatedSubscription.trialDays =
          prices.recurring.subscription.trial_days;

        that.$store.commit(
          `subscriptions/${SET_SUBSCRIPTION_PLAN_PRICING}`,
          updatedSubscription
        );

        that.loading = false;
      });
    });
  }

  subscribe(subscriptionPlanId: number) {
    // Scoping...
    let that = this;
    // @ts-ignore
    // eslint-disable-next-line no-undef
    Paddle.Checkout.open({
      product: subscriptionPlanId,
      email: this.user.email,
      passthrough: this.user.id,
      successCallback() {
        //
        // Todo: update subscription here or let the webhook handle this?
        //
        // Check status...
        that.pollSubscriptions();
        //
        // Show a message to the user
        that.$message({
          message: "Thank you for upgrading.",
          type: "success",
        });
      },
      closeCallback: function () {
        //
        // Don't do anything yet
      },
    });
  }

  pollSubscriptions() {
    this.timesPolled++;
    this.loading = true;
    this.poller = setTimeout(() => {
      this.$store.dispatch("subscriptions/getSubscriptions").then(() => {
        if (!this.hasActiveSubscription && this.timesPolled < 5) {
          this.pollSubscriptions();
        } else {
          // cancel the timeout
          clearTimeout(this.poller);
          // cancel loading
          this.loading = false;
          this.timesPolled = 0;
        }
      });
    }, 2000);
  }
}
